module.exports = __webpack_public_path__ + "static/media/OtherDroppedTileSort.1e2c9b4e.jpg";